import {
  GetAWRListParams,
  GetAWRListResponse,
  GetFiftyTwoWeekAverageSummaryListParams,
  GetFiftyTwoWeekAverageSummaryListResponse,
  GetHolidayPayBalanceDetailListParams,
  GetHolidayPayBalanceDetailListResponse,
  GetHolidayPayBalanceSummaryListParams,
  GetHolidayPayBalanceSummaryListResponse,
  GetNetPayListParams,
  GetNetPayListResponse,
  GetRTWListParams,
  GetRTWListResponse,
  GetWTRListParams,
  GetWTRListResponse,
} from '@nxsys/store/slices/report/types';
import axios from '../axios';
import { endPoints } from '../endpoints';

export const getHolidayPayListApi = async (
  params: GetHolidayPayBalanceDetailListParams,
): Promise<GetHolidayPayBalanceDetailListResponse> => {
  const response = await axios.get(endPoints.payroll.holidayPay, { params });
  return response.data;
};

export const getHolidayPayBalanceSummaryListApi = async (
  params: GetHolidayPayBalanceSummaryListParams,
): Promise<GetHolidayPayBalanceSummaryListResponse> => {
  const response = await axios.get(endPoints.report.payroll.holidayPaySummary, {
    params,
  });
  return response.data;
};

export const getNetPayListApi = async (
  params: GetNetPayListParams,
): Promise<GetNetPayListResponse> => {
  const response = await axios.get(endPoints.payroll.netPay, {
    params,
  });
  return response.data;
};

export const getFiftyTwoWeekAverageSummaryListApi = async (
  params: GetFiftyTwoWeekAverageSummaryListParams,
): Promise<GetFiftyTwoWeekAverageSummaryListResponse> => {
  const response = await axios.get(
    endPoints.report.payroll.fiftyTwoWeekAverageSummary,
    {
      params,
    },
  );
  return response.data;
};

export const getRTWListApi = async (
  params: GetRTWListParams,
): Promise<GetRTWListResponse> => {
  const response = await axios.get(endPoints.report.employee.rtw, {
    params,
  });
  return response.data;
};

export const getAWRListApi = async (
  params: GetAWRListParams,
): Promise<GetAWRListResponse> => {
  const response = await axios.get(endPoints.report.employee.awr, {
    params,
  });
  return response.data;
};

export const getWTRListApi = async (
  params: GetWTRListParams,
): Promise<GetWTRListResponse> => {
  const response = await axios.get(endPoints.report.employee.wtr, {
    params,
  });
  return response.data;
};
